// ===============================================
// 4. CollapsibleInsights.jsx - NEW COMPONENT
// ===============================================

import { useState, useEffect } from 'react';
import { 
  Paper, 
  Box, 
  Typography, 
  IconButton, 
  Collapse, 
  useTheme, 
  useMediaQuery 
} from '@mui/material';
import { ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon } from '@mui/icons-material';

const CollapsibleInsights = ({ insights, isLoading }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [isExpanded, setIsExpanded] = useState(!isMobile);

  useEffect(() => {
    setIsExpanded(!isMobile);
  }, [isMobile]);

  if (isLoading) {
    return (
      <Paper variant='outlined' sx={{ p: 2, border: 'none' }}>
        <Skeleton variant="text" width="60%" height={32} />
        <Skeleton variant="rectangular" height={100} sx={{ mt: 2 }} />
      </Paper>
    );
  }

  return (
    <Paper variant='outlined' sx={{ p: 2, border: 'none' }} component="aside">
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        mb: isExpanded ? 2 : 0
      }}>
        <Typography variant="h6" component="h3">
          Insights
        </Typography>
        {isMobile && (
          <IconButton 
            onClick={() => setIsExpanded(!isExpanded)}
            size="small"
          >
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        )}
      </Box>
      
      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <Box>
          {insights.map((insight, index) => (
            <Box key={index} sx={{ mb: index < insights.length - 1 ? 3 : 0 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                {insight.icon}
                <Typography variant="subtitle2" sx={{ fontWeight: 'medium' }}>
                  {insight.title}
                </Typography>
              </Box>
              <Typography variant="body2" color="text.secondary">
                {insight.content}
              </Typography>
            </Box>
          ))}
        </Box>
      </Collapse>
    </Paper>
  );
};

export default CollapsibleInsights;
